import { render, staticRenderFns } from "./RightItem.vue?vue&type=template&id=9b5401d2&scoped=true&"
import script from "./RightItem.vue?vue&type=script&lang=js&"
export * from "./RightItem.vue?vue&type=script&lang=js&"
import style0 from "./RightItem.vue?vue&type=style&index=0&id=9b5401d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5401d2",
  null
  
)

export default component.exports